export default {
  statistics: {
    total_followers: 'Total followers',
    emails_sent: 'Emails sent',
    emails_opened: 'Emails opened',
    emails_clicked: 'Emails clicked',
    emails_average_open_rate: 'Emails open rate',
    emails_average_click_rate: 'Emails click rate',
    push_notifications_sent: 'Push notifications sent',
    push_notifications_clicked: 'Push notifications clicked',
  },
};
